module.exports = "<div>\n  <p>&copy; Система диагностики профессиональных компетенций (СДПК), 2018</p>\n  <br/>\n</div>\n";